import {
    Component,
    EventEmitter,
    HostListener,
    Input,
    OnInit,
    Output,
    ViewChild,
    ViewChildren,
    ViewEncapsulation,
} from '@angular/core';
import { Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { DateRangeData, PSIC_COMPONENTS } from '@pacificspecialtyinsurancecompany/psic-ng-components';
import { PillsService } from './pills.service';
import { MatChipOption, MatChipListbox } from '@angular/material/chips';
import { CommonModule } from '@angular/common';
import { MatMenuModule } from '@angular/material/menu';
import { FormsModule } from '@angular/forms';
import { SearchFilterPipe } from './search-filter-pipe';
import { MatFormField } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';

@Component({
    selector: 'app-pills',
    templateUrl: './pills.component.html',
    styleUrls: ['./pills.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [
        CommonModule,
        FormsModule,
        MatChipOption,
        MatChipListbox,
        MatMenuModule,
        ...PSIC_COMPONENTS,
        SearchFilterPipe,
        MatFormField,
        MatInput,
        MatIcon,
    ],
})
export class PillsComponent implements OnInit {
    FILTER_BY_NAME = 'Filter by name';
    GEN_RCVD_DATE = 'Generated / Received date';
    COMM_SENT = 'Communication Sent';
    DATE_FILTER = 'Date';
    @Input()
    pills: any;
    @Input() selectable: boolean;
    @Input() multiple = false;
    @Input() clicked = false;
    @Input() showSubtext = true;
    @Output() filteredDataList = new EventEmitter();
    @ViewChildren('mc') mc: any;
    @Input() sentRangeValue: DateRangeData | null = new DateRangeData();
    @Input() rcvdRangeValue: DateRangeData | null = new DateRangeData();
    selectAll: any;
    searchInput: string;
    count = 0;
    openMobilePopup: boolean;
    mobileDialogPillData: any;
    mobileSearchAnimation: boolean = false;
    mobileFullScreen: boolean = false;
    defaultSearchList: any[] = [];
    categoryPills: any[] = [];
    @Input() filteredDataFilter: any[] = [];

    constructor(public router: Router, private pillsService: PillsService) {}

    @HostListener('document:click', ['$event'])
    onDocumentClick(event: Event) {
        // Handle document click if needed
    }

    ngOnInit(): void {
        this.arrangePillsByCategory();

        this.pillsService.currentFilteredData.subscribe((data: any) => {
            this.filteredDataFilter = data;
        });
    }

    ngOnChanges() {
        this.arrangePillsByCategory();
    }

    categoryData = new Observable();
    arrangePillsByCategory() {
        let pillsLoaded = false;
        if (!pillsLoaded) {
            setTimeout(() => {
                if (this.pills && this.pills.length > 0) {
                    pillsLoaded = true;
                    this.pills.forEach((element: any) => {
                        if (this.router.url === '/dashboard/notification-center') {
                            if (element.data.name === 'Category') {
                                this.categoryData = of(element);
                                this.preparePillsData();
                            }
                        }
                    });
                } else {
                    this.arrangePillsByCategory();
                }
            }, 100);
        }
    }

    isFiltered(data: any): boolean {
        for (let i = 0; i < this.filteredDataFilter.length; i++) {
            if (data.name === this.filteredDataFilter[i].name) {
                return true;
            }
        }
        return false;
    }

    cancelDateChange(pillData: any) {
        let currentFilteredData = this.filteredDataFilter.filter((filter: any) => {
            return filter.name === pillData.name;
        });

        if (currentFilteredData.length === 0) {
            if (pillData.name === this.COMM_SENT) {
                this.rcvdRangeValue = new DateRangeData();
            } else if (pillData.name === this.GEN_RCVD_DATE) {
                this.sentRangeValue = new DateRangeData();
            } else if (pillData.name === this.DATE_FILTER) {
                this.rcvdRangeValue = new DateRangeData();
            }

            pillData.items = [];
            pillData.selected = false;
            pillData.selectedItems = 0;
        } else {
            let filteredItem = this.filteredDataFilter[0].items[0];
            if (pillData.name === this.COMM_SENT) {
                this.rcvdRangeValue = {
                    from: filteredItem.from,
                    to: filteredItem.to,
                };
            } else if (pillData.name === this.GEN_RCVD_DATE) {
                this.sentRangeValue = {
                    from: filteredItem.from,
                    to: filteredItem.to,
                };
            } else if (pillData.name === this.DATE_FILTER) {
                this.rcvdRangeValue = {
                    from: filteredItem.from,
                    to: filteredItem.to,
                };
            }
            pillData.items = [];
            pillData.items.push(filteredItem);
        }
    }

    cancelFilterChange(pillData: any) {
        const currentFilteredData = this.filteredDataFilter.filter((f: any) => f.name === pillData.name);

        if (currentFilteredData.length !== 0) {
            pillData.selected = true;
            pillData.selectedItems = currentFilteredData.length;
            pillData.items = [];
            pillData.items.push(currentFilteredData[0].items);
        } else {
            pillData.items.forEach((item: any) => {
                item.selected = false;
            });
            pillData.selected = false;
            pillData.selectAll = false;
            pillData.selectedItems = 0;
        }
    }

    cancelCurrentFilter(pillData: any) {
        if (pillData.isFiltered) return;

        pillData.items?.forEach((item: any) => {
            item.selected = false;
        });
        pillData.selectAll = false;
        pillData.selectedItems = 0;
    }

    cancelDateFilter(data: any) {
        if (!data.isFiltered) {
            this.cancelDateChange(data);
        }
    }

    preparePillsData() {
        this.categoryData.subscribe((ele: any) => {
            this.pills.splice(this.pills.indexOf(ele), 1);
            ele.data.items.forEach((element: any) => {
                let category = {
                    data: {
                        name: element.key,
                        selectedItems: element.doc_count,
                    },
                };
                this.pills.push(category);
            });
        });
    }

    clickOut(pillData?: any) {
        this.pills.forEach((pill: any) => {
            pill.data.isOpened = false;
        });
        if (
            pillData.name === this.GEN_RCVD_DATE ||
            pillData.name === this.COMM_SENT ||
            pillData.name === this.DATE_FILTER
        ) {
            this.cancelDateFilter(pillData);
        } else {
            this.cancelCurrentFilter(pillData);
        }
    }

    interactiveSearch() {
        this.mobileSearchAnimation = false;
        this.mobileFullScreen = true;
    }

    resetFilter() {
        this.searchInput = '';
        this.filteredDataFilter = [];
    }

    applyFilter(pillData: any, singlePillFilter?: boolean) {
        this.searchInput = '';

        if (singlePillFilter) {
            this.checkCount(pillData);
        }

        const data = pillData.data !== undefined ? pillData.data : pillData;
        data.isOpened = false;

        const existingIndex = this.filteredDataFilter.findIndex((e: any) => e.name === data.name);
        const hasSelected = data.items?.some((item: any) => item.selected);

        if (hasSelected) {
            data.isFiltered = true;
            if (existingIndex >= 0) {
                this.filteredDataFilter[existingIndex] = data;
            } else {
                this.filteredDataFilter.push(data);
            }
        } else {
            data.isFiltered = false;
            if (existingIndex >= 0) {
                this.filteredDataFilter.splice(existingIndex, 1);
            }
        }

        this.filteredDataList.emit(this.filteredDataFilter);
    }

    selectAllItems(data: any) {
        if (data.selectAll) {
            data.items.map((item: any) => {
                return (item.selected = true);
            });
        } else if (!data.selectAll && data.selectedItems == 0) {
            data.items.map((item: any) => {
                return (item.selected = false);
            });
        } else if (!data.selectAll && data.selectedItems == data.items.length) {
            data.items.map((item: any) => {
                return (item.selected = false);
            });
        }

        this.checkCount(data);
    }

    checkDate(pillData: any, event: any) {
        let checkedObj = { type: '', key: '', from: '', to: '', selected: false };
        if (event.from !== 'Invalid date' && event.to !== 'Invalid date') {
            if (pillData.name === this.GEN_RCVD_DATE) {
                if (this.sentRangeValue) {
                    this.sentRangeValue.from = event!.from!.toLocaleString();
                    this.sentRangeValue.to = event!.to!.toLocaleString();
                    checkedObj.type = this.GEN_RCVD_DATE;
                    checkedObj.key = this.GEN_RCVD_DATE;
                    checkedObj.from = event.from;
                    checkedObj.to = event.to;
                    pillData.selected = true;
                    checkedObj.selected = true;
                }
            } else if (pillData.name === this.COMM_SENT) {
                if (this.rcvdRangeValue) {
                    this.rcvdRangeValue.from = event!.from!.toLocaleString();
                    this.rcvdRangeValue.to = event!.to!.toLocaleString();
                    checkedObj.type = this.COMM_SENT;
                    checkedObj.key = this.COMM_SENT;
                    checkedObj.from = event.from;
                    checkedObj.to = event.to;
                    pillData.selected = true;
                    checkedObj.selected = true;
                }
            } else if (pillData.name === this.DATE_FILTER) {
                if (this.rcvdRangeValue) {
                    this.rcvdRangeValue.from = event!.from!.toLocaleString();
                    this.rcvdRangeValue.to = event!.to!.toLocaleString();
                    checkedObj.type = this.DATE_FILTER;
                    checkedObj.key = this.DATE_FILTER;
                    checkedObj.from = event.from;
                    checkedObj.to = event.to;
                    pillData.selected = true;
                    checkedObj.selected = true;
                }
            }
            pillData.items = [];
            pillData.items.push(checkedObj);
            let count = 0;
            pillData.items.forEach((item: any) => {
                if (item.selected == true) {
                    count++;
                }
            });
            pillData.selectedItems = count;
        }
    }

    checkCount(data: any) {
        let total = 0;
        if (data.data === undefined) {
            data.items.forEach((item: any) => {
                if (item.selected) {
                    if (item.selected == true) {
                        total++;
                    }
                }
            });
            this.count = total;
            data.selectedItems = this.count;
            if (data.selectedItems < data.items.length) {
                data.selectAll = false;
            } else {
                data.selectAll = true;
            }
        } else {
            if (data.data.items.length > 1) {
                data.data.items.forEach((item: any) => {
                    if (item.selected && item.selected == true) {
                        total += item.doc_count;
                    }
                });
            } else {
                data.data.items.forEach((item: any) => {
                    item.selected = true;
                    total = item.doc_count;
                });
            }
            this.count = total;
            data.data.selectedItems = this.count;
            if (data.data.selectedItems < data.data.items.length) {
                data.selectAll = false;
            } else {
                data.selectAll = true;
            }
        }
    }

    searchItems(itemsList: any[]) {
        itemsList.filter((item: any) => {
            return item.name.toLowerCase().includes(this.searchInput.toLowerCase());
        });
    }

    openMobileMenu(data: any) {
        this.openMobilePopup = true;
        this.mobileDialogPillData = data;
    }

    getProuductImg(type: string) {
        let productImage;
        switch (type) {
            case 'HO3':
                productImage = '../../../../../assets/images/icons/64/insurance/home.svg';
                break;
            case 'HO4':
                productImage = '../../../../../assets/images/icons/64/insurance/renters.svg';
                break;
            case 'HO6':
                productImage = '../../../../../assets/images/icons/64/insurance/condo.svg';
                break;
            case 'DP1':
                productImage = '../../../../../assets/images/icons/64/insurance/basic-dwelling.svg';
                break;
            case 'DP3':
                productImage = '../../../../../assets/images/icons/64/insurance/special-dwelling.svg';
                break;
            case 'Street':
                productImage = '../../../../../assets/images/icons/64/insurance/motorcycle.svg';
                break;
            case 'OffRoad':
                productImage = '../../../../../assets/images/icons/64/insurance/off-road.svg';
                break;
            case 'MCST':
                productImage = '../../../../../assets/images/icons/64/insurance/motorcycle.svg';
                break;
            case 'MCOR':
                productImage = '../../../../../assets/images/icons/64/insurance/off-road.svg';
                break;
            case 'PB':
                productImage = '../../../../../assets/images/icons/64/insurance/boat.svg';
                break;
            case 'PleasureBoat':
                productImage = '../../../../../assets/images/icons/64/insurance/boat.svg';
                break;
            case 'PWC':
                productImage = '../../../../../assets/images/icons/64/insurance/jetski.svg';
                break;
            case 'MH':
                productImage = '../../../../../assets/images/icons/64/insurance/manufactured.svg';
                break;
            case 'CPL':
                productImage = '../../../../../assets/images/icons/64/insurance/personal-liability.svg';
                break;
            case 'PUP':
                productImage = '../../../../../assets/images/icons/64/insurance/liability.svg';
                break;
            case 'EQ':
                productImage = '../../../../../assets/images/icons/64/insurance/home.svg';
                break;

            case 'G':
                productImage = '../../../../../assets/images/icons/64/insurance/home.svg';
                break;
            case 'F':
                productImage = '../../../../../assets/images/icons/64/insurance/renters.svg';
                break;
            case 'X':
                productImage = '../../../../../assets/images/icons/64/insurance/condo.svg';
                break;
            case 'Y':
                productImage = '../../../../../assets/images/icons/64/insurance/basic-dwelling.svg';
                break;
            case 'T':
                productImage = '../../../../../assets/images/icons/64/insurance/motorcycle.svg';
                break;
            case 'B':
                productImage = '../../../../../assets/images/icons/64/insurance/off-road.svg';
                break;
            case 'C':
                productImage = '../../../../../assets/images/icons/64/insurance/boat.svg';
                break;
            case 'D':
                productImage = '../../../../../assets/images/icons/64/insurance/jetski.svg';
                break;
            case 'O':
                productImage = '../../../../../assets/images/icons/64/insurance/personal-liability.svg';
                break;
            case 'R':
                productImage = '../../../../../assets/images/icons/64/insurance/liability.svg';
                break;
            case 'Z':
                productImage = '../../../../../assets/images/icons/64/insurance/home.svg';
                break;

            default:
                productImage = '../../../assets/images/Generic.svg';
                break;
        }
        return productImage;
    }
}
